import { render, staticRenderFns } from "./DrugGroup.vue?vue&type=template&id=7571b394&scoped=true&"
import script from "./DrugGroup.vue?vue&type=script&lang=js&"
export * from "./DrugGroup.vue?vue&type=script&lang=js&"
import style0 from "./DrugGroup.vue?vue&type=style&index=0&id=7571b394&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7571b394",
  null
  
)

export default component.exports